const TOKEN_MAX_TTL = process.env.VUE_APP_AUTH_TOKEN_MAX_TTL;
const TOKEN_EXPIRATION_HEADER_NAME = process.env.VUE_APP_AUTH_TOKEN_EXPIRATION_HEADER_NAME;
const TOKEN_EXPIRATION_KEY = process.env.VUE_APP_AUTH_TOKEN_EXPIRATION_KEY;
const LAST_ACTIVITY_TIMESTAMP_KEY = process.env.VUE_APP_LAST_ACTIVITY_TIMESTAMP_KEY;
const TOKEN_TTL_REFRESH_TRIGGER = TOKEN_MAX_TTL * 0.2; // refresh token whenever it "loses" 20% of ttl
const INACTIVITY_TIME_LIMIT = TOKEN_MAX_TTL; // inactivity limit = token time to live
const INACTIVITY_TIME_MODAL_TRIGGER = TOKEN_MAX_TTL * 0.95; // show modal whenever 5% of ttl is left (3 minutes for 60 minutes token ttl)

export default {
    TOKEN_MAX_TTL,
    TOKEN_EXPIRATION_HEADER_NAME,
    TOKEN_EXPIRATION_KEY,
    TOKEN_TTL_REFRESH_TRIGGER,
    LAST_ACTIVITY_TIMESTAMP_KEY,
    INACTIVITY_TIME_LIMIT,
    INACTIVITY_TIME_MODAL_TRIGGER
};
